import { Pipe, PipeTransform } from '@angular/core';

// @ts-ignore
import * as moment from 'moment';
// @ts-ignore
import 'moment-timezone';

@Pipe({
  name: 'timezone'
})
export class TimezonePipe implements PipeTransform{
  transform(date: any, timezone :string, format?:string){
    const m:any = moment;

    m.locale('es-MX');

    if (format){
      // @ts-ignore
      return moment(date).tz(timezone).format(format);
    }
    // @ts-ignore
    return moment(date).tz(timezone).format('h:mm a ');
  }
}



// WEBPACK FOOTER //
// ./src/pipes/timezone.ts